import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { IconInformation, SpacerVertical } from '@klarna/bubble-ui';
import { Alert, FlowContext } from 'moet-core';
import { isRunningContextCypress } from 'moet-test-utils/cypress/utils';
import { GridContainer, Row, Column, withResponsive } from 'mage-components';

import { ErrorAlert } from './ErrorAlert';
import PageHeader from './PageHeader';
import { RouteTransitionWrapper } from './RouteTransitionWrapper';

const MerchantPortalContainerComponent = ({
  subtitle,
  title,
  children = null,
  contentWidth = 6,
  info,
  error = undefined,
  tFrontEndError = undefined,
  t,
}) => {
  const { navigation = {} } = useContext(FlowContext);
  return (
    <RouteTransitionWrapper
      name={navigation.key}
      direction={navigation.direction}
      disabled={isRunningContextCypress(window)}
    >
      <GridContainer padding={{ mobile: 4 }}>
        <Row justify={{ desktop: 'center', tablet: 'center' }}>
          <PageHeader title={title} description={subtitle}>
            {error && (
              <>
                <SpacerVertical medium />
                <ErrorAlert error={error} />
              </>
            )}
            <SpacerVertical small />
          </PageHeader>
        </Row>
        <Row justify={{ desktop: 'center', tablet: 'center' }}>
          <Column columns={{ desktop: contentWidth, tablet: 8 }}>
            {tFrontEndError && <Alert type="error" content={t(tFrontEndError)} />}
            {info && (
              <>
                <SpacerVertical small />
                <Alert content={info} icon={IconInformation} />
                <SpacerVertical large />
              </>
            )}
            {children}
          </Column>
        </Row>
        <SpacerVertical extraExtraLarge />
      </GridContainer>
    </RouteTransitionWrapper>
  );
};

MerchantPortalContainerComponent.propTypes = {
  subtitle: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  contentWidth: PropTypes.number,
  error: PropTypes.object,
  info: PropTypes.string,
  t: PropTypes.func,
  tFrontEndError: PropTypes.string,
};

const MerchantPortalContainer = withResponsive(MerchantPortalContainerComponent);
export { MerchantPortalContainer };
